var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader"},[_c('fulfilling-square-spinner',{attrs:{"animation-duration":4000,"size":_vm.convertedSize,"color":_vm.color}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }